import styled from 'styled-components';

const Hamburger = styled.div`
  &,
  &:before,
  &::after {
    position: absolute;
    width: 12px;
    height: 2px;
    transition-timing-function: ease;
    transition-duration: 0.15s;
    transition-property: transform;
    border-radius: 1px;
    background-color: #C0C0C0;
  }
  top: 5px;
  left: 7px;
  &:before {
    content: '';
    top: 5px;
    left: 0px;
    transition-timing-function: ease;
    transition-duration: 0.15s;
    transition-property: transform, opacity;
  }

  &:after {
    content: '';
    top: 10px;
    left: 0px;
  }
  ${(props) =>
    props.isActive &&
    `
    transform: rotate(45deg) translate(4px, 4px);
    &::before {
      transform: rotate(-45deg);
      opacity: 0;
    }
    &::after {
      transform: rotate(-90deg) translate(10px, 0);
    }
  `}
`;

export default Hamburger;
